import { useRouter } from 'next/router';

import { type BreadcrumbItem, Breadcrumbs } from 'shared/page/Breadcrumbs';
import type { Filters } from '../interfaces';
import { addResultPageFiltersToUrl } from '../lib/utils/queryParamFilterConversions';

interface Props {
    hotelName?: string;
    filters?: Filters;
}

export const PpBreadcrumbs = ({ hotelName, filters }: Props) => {
    const router = useRouter();
    const resultPath = `${router.basePath}/resultat`;
    const items: BreadcrumbItem[] = [
        { url: '/reise/', title: 'Reise' },
        { url: '/reise/pakkereiser/', title: 'Pakkereiser' },
        { url: filters ? addResultPageFiltersToUrl(resultPath, filters) : resultPath, title: 'Resultat' },
        ...(hotelName ? [{ url: '#', title: hotelName }] : []),
    ];

    return <Breadcrumbs items={items} />;
};
